var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GeneralMandatoryAction50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36,
    r: 3,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27,11.492c-0.256-1.462-1.545-2.485-3-2.483c-1.455-0.001-2.744,1.022-3,2.483 c-0.06,0.344-0.056,0.696,0,1.021l1.894,17.509C22.954,30.578,23.43,31,23.998,31H24h0.002c0.568,0,1.044-0.422,1.104-0.978 L27,12.513C27.056,12.187,27.06,11.835,27,11.492z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GeneralMandatoryAction50);
export default __webpack_public_path__ + "static/media/icons8-general-mandatory-action-50.17260ba051faf971c70683abe1558bf0.svg";
export { ForwardRef as ReactComponent };